import {
  getInternationalPriceNuqlium,
  getFormData,
  nuqliumDataIndexSeven,
  devOrProdFeeds,
  nuqliumDataIndexSevenFeeds
} from './utils';

const devOrProd = process.env.REACT_APP_DEVORPROD;
const internationalPrice = getInternationalPriceNuqlium();

export const productInfoPDP = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProd +
    '/index.php',
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSeven(),
    output: 'json',
    pagetype: 'pages',
    pagekey: 'seven-react-pdp-product-information',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

export const recommendedProductsSeven = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProd +
    '/index.php',
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSeven(),
    output: 'json',
    pagetype: 'recommendations',
    pagekey: 'nq-recommendation-new-sevenstore-pdp-you-may-also-like',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

export const recommendedProductsSevenSale = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProd +
    '/index.php',
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSeven(),
    output: 'json',
    pagetype: 'recommendations',
    pagekey: 'nq-recommendation-new-sevenstore-pdp-sale',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

export const bfNQFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=',
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey:
      devOrProd === 'dev' ? 'nq-new-arrivals-all-feed' : 'nq-feed-bf-all',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

export const recentlyViewedSeven = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProd +
    '/index.php',
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSeven(),
    output: 'json',
    pagetype: 'recommendations',
    pagekey: 'nq-recommendation-new-sevenstore-pdp-recently-viewed',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

// Product Recommendations - Quick View
export const nuqliumApiFunc = (prodID) => {
  return {
    endPointUrl:
      'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
      devOrProd +
      '/index.php',
    endPointPrams: new URLSearchParams({
      DataIndex: nuqliumDataIndexSeven(),
      output: 'json',
      pagetype: 'product',
      pagekey: prodID,
      'settings[pricelist]': internationalPrice,
      'settings[mode]': 'web'
    })
  };
};

// Mini Bakset - Preview
export const miniBasketNQApiFunc = (prodID) => {
  return {
    endPointUrl:
      'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
      devOrProd +
      '/index.php',
    endPointPrams: new URLSearchParams({
      DataIndex: nuqliumDataIndexSeven(),
      output: 'json',
      pagetype: 'product',
      pagekey: prodID,
      'settings[pricelist]': internationalPrice,
      'settings[mode]': 'web'
    })
  };
};
